import axios from "axios";
import { ActionContext, Module } from "vuex";

import { auth as manager } from "@/auth";
import { RootState } from "@/store/root";
import { Evidence } from "@/types";

interface RawEvidence {
  code: string;
  codename: string;
  tokspans: any[];
  better_matches: string[];
  lacking: string[];
  pratio: number;
  score: number;
  prereqs: {
    required: boolean;
    reqlist: string[];
  };
}

export const iclive: Module<{}, RootState> = {
  namespaced: true,
  actions: {
    async update(context: ActionContext<{}, RootState>, terms: string[]) {
      // eslint-disable-next-line no-control-regex
      const text = context.rootState.raw.replace(/[^\x00-\x7F]/g, "");

      await context.dispatch("matches/update", text, { root: true });

      const response = await axios.post(
        (context.rootState as any).settings.current.endpoints.customEncode,
        {
          document: { pages: [{ date: "", text, action: "include" }] },
          queries: terms
        },
        {
          headers: manager.enabled ? await manager.headers() : {}
        }
      );

      const evidences = response.data.icd.imatches
        .filter((match: any) => Object.keys(match).length)
        .map((evidence: RawEvidence) => ({
          id: evidence.code,
          desc: evidence.codename,
          spans: evidence.tokspans.filter(span => span.length),
          billable: true,
          score: evidence.score,
          pratio: evidence.pratio,
          better_matches: evidence.better_matches.filter(Boolean),
          lacking: evidence.lacking.filter(Boolean),
          prereqs: {
            required: evidence.prereqs.required,
            codes: evidence.prereqs.reqlist
          },
          type: "custom"
        }));

      const found = new Set(evidences.map((evidence: any) => evidence.desc));

      const notFound = terms
        .map((term, index) => [term, index] as const)
        .filter(([term]) => !found.has(term))
        .map(
          ([term, index]): Evidence => ({
            id: String(index),
            desc: term,
            type: "custom",
            spans: []
          })
        );

      context.commit(
        "evidences/UPDATE",
        [
          ...(context.rootState as any).evidences.list.filter(
            (evidence: any) => evidence.type !== "custom"
          ),
          ...evidences,
          ...notFound
        ],
        {
          root: true
        }
      );
    }
  }
};
